/* eslint-disable react/jsx-key */
/* eslint-disable id-length */
/* eslint-disable functional/prefer-readonly-type */
import React from 'react'
import { FormControl, Button, Box, Typography } from '@mui/material'
import { type State, useHookstate } from '@hookstate/core'
import ModalDrawMap from './Components/MapModal'
import type ICity from '~/features/City/interfaces/ICity'
import { LocationPrediction } from '~/utils/location'
import { Map } from '@mui/icons-material'
import { useTheme } from '@mui/material/styles'
import { useTheme as useThemeLocal } from '~/hooks/useTheme'
import { useLang } from '~/hooks/useLang'

interface FilterGeographicalAreaProps {
  readonly localTextValue: State<string | null>
  readonly lat: State<string>
  readonly long: State<string>
  readonly city?: State<ICity | null>
  readonly district?: State<{ id: string | null; name: string }>
  readonly error?: boolean
  isRequired?: boolean
}

export default function FilterGeographicalSinglePoint({
  lat,
  long,
  city,
  district,
  localTextValue,
  error = false,
  isRequired = false,
}: FilterGeographicalAreaProps) {
  const theme = useTheme()
  const geographicalArea = useHookstate<
    string | object | LocationPrediction | LocationPrediction[] | null
  >(null)
  const openModalGeographicalArea = useHookstate<boolean>(false)
  const { translate } = useLang()
  const { darkMode } = useThemeLocal()

  // Label exibido no "input"
  const label = localTextValue.get() || translate('Select a location')

  return (
    <>
      <FormControl fullWidth size="small">
        <Button
          variant="outlined"
          onClick={() => openModalGeographicalArea.set(true)}
          sx={{
            justifyContent: 'flex-start',
            textTransform: 'none',
            color: error
              ? theme.palette.error.main
              : theme.palette.text.primary,
            background: 'transparent',
            borderColor: error
              ? theme.palette.error.main
              : darkMode
              ? 'rgba(255, 255, 255, 0.25)'
              : 'rgba(0, 0, 0, 0.25)',
            height: 40,
            paddingLeft: 2,
            paddingRight: 2,
            '&:hover': {
              borderColor: error
                ? theme.palette.error.main
                : darkMode
                ? theme.palette.primary.light
                : theme.palette.primary.main,
            },
          }}
          fullWidth
        >
          <Box sx={{ flex: 1, textAlign: 'left', overflow: 'hidden' }}>
            <Typography
              variant="body2"
              color={
                error
                  ? theme.palette.error.main
                  : !localTextValue.get()
                  ? 'text.disabled'
                  : 'text.primary'
              }
              sx={{
                color: 'inherit',
                opacity: 0.7,
                fontSize: '1rem',
                lineHeight: '1.5rem',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {localTextValue.get()
                ? localTextValue.get()
                : isRequired
                ? `${translate('Select a location')} *`
                : translate('Select a location')}
            </Typography>
          </Box>
          <Map
            fontSize="small"
            sx={{ ml: 1, color: error ? theme.palette.error.main : undefined }}
          />
        </Button>
      </FormControl>

      <ModalDrawMap
        isOpen={openModalGeographicalArea}
        geographicalArea={geographicalArea}
        lat={lat}
        long={long}
        city={city}
        district={district}
        localTextValue={localTextValue}
      />
    </>
  )
}
